import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

export const ViewContainer = styled.div`
  width: 100%;
  position: relative;
  min-height: 100rem;
  padding: 5rem 10rem 30rem 10rem;
  gap: 4rem;
  display: grid;
  grid-template-columns: calc(50% - 2px - 4rem) 2px calc(50% - 4rem);
  grid-template-rows: 100%;
  @media (max-width: 1025px) {
    display: inline;
    padding: 5rem 1rem 30rem 1rem;
  }

  .middle {
    width: 100%;
    height: 80%;
    background-color: ${(props) => props.theme.colors.elements};
    align-self: center;
  }
  
  .right{
    @media(max-width: 768px){
      margin-top: 15px;
    }
  }

  /* Sem o deslize do SlidingBox no mobile: o translateX(500%) ao entrar na tela
     deixava a página com scroll horizontal enorme */
  @media (max-width: 1024px) {
    .left ~ .right > div > div > .right,
    .left ~ .right > div > .right {
      transform: none;
      transition: none;
    }
  }

  .left,
  .right {
    gap: 2rem;
    position: relative;
    color: ${(props) => props.theme.colors.tertiary};
    display: flex;
    min-height: 100%;
    flex-direction: column;
    justify-content: flex-start;

    @media (max-width: 1024px) {
      padding: 0 3rem;
      &.ativo{
        padding: 0;
      }
    }

    .botoes {
      padding: 0;
      display: flex;
      align-items: flex-end;
      height: 100%;
      justify-content: space-between;
      .salvar {
        .botao_avancado {
          cursor: pointer;
          margin: 15px 0;
          color: ${(props) => props.theme.colors.primary};
        }
      }
      .voltar {
        cursor: pointer;
      }
    }

    .midias {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      grid-gap: 20px;

      .center {
        display: flex;
        justify-content: center;
        align-items: center;
        aspect-ratio: 1;
        width: 100%;
        max-width: 100%;
        height: 100%;

        .adicionar_produto {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background-color: ${(props) => props.theme.colors.primary};
          border-radius: 15px;

          .plus {
            fill: ${(props) => props.theme.colors.white};
          }

          .locked{
            svg{
              fill: ${(props) => props.theme.colors.white};
              path{
                fill: ${(props) => props.theme.colors.white};
              }
            }

            &::after{
              position: fixed;
              left: 49rem;
              top: 46rem;
            }
          }
        }
      }

      .imagem {
        width: 100%;
        height: 100%;
        position: relative;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          border-radius: 15px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .icone-apagar {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          padding: 2px;
          background-color: #303030;
          right: 1rem;
          top: 1rem;
          &.visivel {
            display: flex;
          }

          &.invisivel {
            display: none;
          }

          cursor: pointer;
          svg {
            height: 3rem;
            width: auto;
            fill: #e1e1e1;
            transform: rotate(45deg);
          }
        }

        .icone-esquerda {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          padding: 2px;
          left: 1rem;
          top: calc(50% - 3px);
          cursor: pointer;

          &.visivel {
            display: flex;
          }

          &.invisivel {
            display: none;
          }
          svg {
            height: 3rem;
            width: auto;
            fill: #e1e1e1;
          }
        }

        .icone-direita {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          padding: 2px;
          right: 1rem;
          top: calc(50% - 3px);
          cursor: pointer;

          &.visivel {
            display: flex;
          }

          &.invisivel {
            display: none;
          }
          svg {
            height: 3rem;
            transform: rotate(180deg);
            width: auto;
            fill: #e1e1e1;
          }
        }

        .imagem-selector {
          position: absolute;
          bottom: 0.8rem;
          left: 0.8rem;
          right: 0.8rem;
          z-index: 3;
        }

        .melhorar-ia {
          position: absolute;
          top: 1rem;
          left: 1rem;
          z-index: 4;
          display: none;
          flex-direction: row;
          align-items: center;
          background: ${(props) => props.theme.colors.borderGradient};
          border-radius: 7px;
          padding: 1px;
          cursor: pointer;

          &.visivel {
            display: flex;
          }
          &.invisivel {
            display: none;
          }

          /* Em touch (sem hover) o botão aparece sempre, já que não há hover. */
          @media (hover: none) {
            &.visivel,
            &.invisivel {
              display: flex;
            }
          }

          &::after {
            content: "";
            position: absolute;
            inset: 1px;
            background: ${(props) => props.theme.colors.background2};
            border-radius: 6px;
            z-index: 0;
          }

          .conteudo-melhorar {
            position: relative;
            z-index: 1;
            display: flex;
            align-items: center;
            gap: 0.6rem;
            padding: 0 1.2rem;
            /* Fontes no projeto são em px (o :root usa font-size pequeno p/ escalar rem no layout).
               Espelha a classe .fonteRotulos (12px / 10px mobile). */
            font-size: 12px;
            white-space: nowrap;
            color: ${(props) => props.theme.colors.tertiary};

            @media (max-width: 768px) {
              font-size: 10px;
            }
          }

          .descricao-ia {
            width: 16px;
            height: 16px;
            fill: ${(props) => props.theme.colors.tertiary};
          }
        }
      }
      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    .cadastro {
      width: 100%;

      .tem-variacao {
        width: 100%;
        border-radius: 15px;
        border: solid 1px
          ${(props) => (props.theme.mode == "light" ? "#dbdbdb" : "#434343")};
        padding: 10px 5px;
        margin-bottom: 15px;

        .topo {
          display: flex;
          padding-left: 15px;
          align-items: center;
          color: ${(props) =>
    props.theme.mode == "light"
      ? "#434343"
      : props.theme.colors.tertiary};

          div {
            margin-right: 10px;
          }
        }

        .texto-variacao {
          margin-top: 10px;
          text-align: left;
          padding-left: 15px;
        }

        .tem-estoque {
          padding-left: 15px;
        }
      }

      .textarea {
        margin-top: 10px;
        .titulo-campo{
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 8px;
          
          .label{
            width: 100%;
            font-weight: normal;
            color: ${(props) => props.theme.colors.tertiary};
            display: flex;
            align-items: center;
            text-align: justify;
            white-space: normal;
            padding: 5px 0;
          }

          .gerar-descricao-ia{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 1rem;
            position: relative;
            border: none;
            background: ${(props) => props.theme.colors.borderGradient};
            border-radius: 8px;
            padding: 1px;
            width: 44rem;
            color: ${(props) => props.theme.colors.tertiary};
            cursor: pointer;
            
            &::after {
              content: "";
              position: absolute;
              inset: 1px;
              background: ${(props) => props.theme.colors.background2};
              border-radius: 7px;
              z-index: 0;
            }
            
            > * {
              position: relative;
              z-index: 1;
              color: ${(props) => props.theme.colors.tertiary};
            }

            @media (max-width: 768px) {
              width: 55rem;
            }

            .descricao-ia{
              width: 16px;
              height: 16px;
              fill: ${(props) => props.theme.colors.tertiary};
            }
          }
        }
      }

      .sku-peso {
        display: flex;
        justify-content: space-between;
        grid-gap: 2rem;
        margin-top: 5rem;

        .sku {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          width: 95%;

          .inputComponentContainer {
            width: 90%;
          }

          .gerar {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: ${(props) => props.theme.colors.elements};
            border-radius: 10rem;
            width: 60px;
            height: 6rem;
            margin-left: -10rem;
            z-index: 2;
            cursor: pointer;

            .gerar-texto {
              color: ${(props) => props.theme.colors.tertiary};
              text-align: center;
            }
          }
        }

        .peso {
          width: 95%;
          position: relative;

          .conversor-peso {
            position: absolute;
              top: 105%;
            left: 2rem;
            font-size: 1.8rem;
            color: ${(props) => props.theme.colors.placeholder};
          }
        }
      }

      .categoria {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 15px;
        gap: 1rem;

        .view-select {
          width: 100%;
        }

        .mais {
          background-color: ${(props) => props.theme.colors.elements};
          color: ${(props) => props.theme.colors.tertiary};
          display: flex;
          gap: 10px;
          position: relative;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          border-radius: 32px;
          width: auto;
          height: 36px;
          cursor: pointer;
          padding: 8px 16px;
          @media (max-width: 768px) {
            height: 30px;
          }

          .plus {
            width: 18px;
            fill: ${(props) => props.theme.colors.primary};

            @media (max-width: 768px) {
              width: 14px;
            }
          }
        }
      }

      .precos-lista-container {
        margin-top: 15px;
        overflow-x: scroll;
        padding-bottom: 1rem;
        scrollbar-width: thin;
        scrollbar-color: ${(props) => props.theme.colors.elements} transparent;
        
        &::-webkit-scrollbar {
          height: 25px;
          display: block;
        }

        &::-webkit-scrollbar-button {
          display: none;
        }

        &::-webkit-scrollbar-thumb {
          border: 10px solid rgba(0, 0, 0, 0);
          background-clip: padding-box;
          border-radius: 25px;
          background-color: ${(props) => props.theme.colors.elements};
        }
        
        .precos-content {
          display: flex;
          flex-direction: column;
          min-width: fit-content;
        }
        
        .precos-header {
          display: flex;
          gap: 2rem;
          margin-bottom: 2rem;
          margin-right: 25rem;

          .header-item {
            display: flex;
            align-items: center;
            flex: 1;
            min-width: 25rem;

            .titulo-lista {
              text-align: left;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .precos-inputs {
          display: flex;
          gap: 2rem;
          align-items: center;

          .preco-item {
            display: flex;
            position: relative;
            justify-content: center;
            flex: 1;
            min-width: 25rem;
          }

          .nova-lista-header {
            .mais {
              background-color: ${(props) => props.theme.colors.elements};
              color: ${(props) => props.theme.colors.tertiary};
              display: flex;
              gap: 10px;
              position: relative;
              justify-content: center;
              align-items: center;
              white-space: nowrap;
              border-radius: 32px;
              width: auto;
              height: 36px;
              cursor: pointer;
              padding: 8px 16px;
              @media (max-width: 768px) {
                height: 30px;
              }

              .plus {
                width: 18px;
                fill: ${(props) => props.theme.colors.primary};
                @media (max-width: 768px) {
                  width: 14px;
                }
              }

              .blocked {
                svg {
                  path {
                    fill: ${(props) => props.theme.colors.primary};
                  }
                }

                &::after {
                  bottom: 5rem;
                  right: -14px;
                }
              }
            }
          }
        }
      }

      .linha {
        margin-top: 3rem;
        width: 100%;
        height: 0.5px;
        background-color: ${(props) => props.theme.colors.elements};
        border-radius: 50px;
      }

      .tem-estoque {
        display: flex;
        align-items: center;
        margin: 16px 0;
        label{
          display: flex;
          align-items: center;
        }
        div {
          margin-right: 1rem;
        }
        svg{
          width: 3rem;
        }
      }

      .estoque-unico {
        margin-top: 3rem;
      }

      .tem-destaque {
        display: flex;
        align-items: center;
        margin: 16px 0;
        label{
          display: flex;
          align-items: center;
        }
        div {
          margin-right: 1rem;
        }
        svg{
          width: 3rem;
        }
      }

      .destaque-select {
        .textTags {
          display: block;
          text-align: left;
          color: ${(props) => props.theme.colors.tertiary};
          margin-top: 1rem;
          line-height: 1.5;
        }
          .select-tag {
              margin-bottom: 4rem;
          }
      }

      .caracteristicas-box {
        margin-top: 16px;
      }
    }

    .avancado {
      margin-top: 4rem;

      .titulo-avancado {
        text-align: left;
      }

      .inputs-avancado {
        margin-top: 4rem;

        .bloco-input {
          margin-top: 4rem;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(40rem, 1fr));
          grid-gap: 2rem;
          align-items: flex-end;
        }

        /* Regra + quantidade + multiplicador empilhados, ocupando a largura toda.
           Rádios no mesmo padrão do brinde (.regraRadios) */
        .bloco-quantidade-minima {
          margin-top: 4rem;
          display: flex;
          flex-direction: column;
          gap: 2rem;
          text-align: left;

          .regra-titulo {
            color: ${(props) => props.theme.colors.tertiary};
            margin-bottom: -1rem;
          }

          .regra-radios {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            label {
              cursor: pointer;
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              align-items: center;
              gap: 1rem;
            }
          }
        }
      }
      .linha {
          margin-top: 3rem;
          width: 100%;
          height: 2px;
          background-color: ${(props) => props.theme.colors.elements};
          border-radius: 50px;
        }
        .catalogos{
          text-align: left;
          .titulo-catalogos{
            margin: 2rem 0;
          }
         .nome{
          margin: 1rem 0;
         }
        }
    }

    .linha {
      display: flex;
      justify-content: center;
      div {
        width: 2px;
        height: 100%;
        background-color: #dbdbdb;
        box-shadow: 0 0 10px #dbdbdb;
      }
    }
  }
`;

export const FooterWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 2rem;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap-reverse;
    
    .footer-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap-reverse;
      gap: 2rem;
    }
    
    .inativar_produto {
      .excluir_produto {
        cursor: pointer;
        color: ${(props) => props.theme.colors.primary};
        @media (max-width: 1024px) {
          min-height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    
    .right-flex {
      white-space: normal;
      display: flex;
      gap: 2rem;
      align-items: center;
      
      a {
        display: contents;
      }
      
      .duplicar {
        .green {
          color: ${(props) => props.theme.colors.primary};
          cursor: pointer;
          @media (max-width: 1024px) {
            min-height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          &.blocked {
            cursor: not-allowed;
            opacity: 0.6;
          }
        }
      }
      
      .salvar {
        width: auto;
        button {
          .blocked{
            &::after{
              right: 0rem;
              top: -6rem;
            }

            svg{
              padding-left: 1rem;
              path{
                fill: ${(props) => props.theme.colors.white};
              }
            }
          }
        }
        @media (max-width: 1024px) {
          width: 100%;
        }
      }
      
      .avancado {
        width: auto;
        button {
          background-color: ${(props) => props.theme.colors.elements};
          font-weight: normal;
          color: ${(props) => props.theme.colors.tertiary};
        }
        @media (max-width: 1024px) {
          width: 100%;
        }
      }
    }
    
    @media (max-width: 1024px) {
      .footer-content {
        .right-flex {
          display: contents;
        }
      }
    }
    
    @media (max-width: 680px) {
      .footer-content {
        gap: 1rem;
        .button {
          width: 100% !important;
        }
      }
    }
`;

export const ContainerDescricaoIa = styled.div<{theme: ThemeType}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .cabecalho-modal-descricao{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    .titulo{
      text-align: center;
      font-weight: bold;
      color: ${({theme}) => theme.colors.secondary};
    }
  
    .texto{
      text-align: center;

      .gerando {
        font-weight: bold;
      }
    }

    .quantidade-tokens{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      gap: 4px;
      position: relative;
      border: none;
      background: ${(props) => props.theme.colors.borderGradient};
      border-radius: 16px;
      padding: 8px 16px;

      &::after {
        content: "";
        position: absolute;
        inset: 1px;
        background: ${(props) => props.theme.colors.modal};
        border-radius: 16px;
        z-index: 0;
      }

      > * {
        position: relative;
        z-index: 1;
      }

      .tokens-ia {
        width: 12px;
        height: 12px;
        padding: 0;

        @media (max-width: 768px) {
          width: 2rem;
          height: 2rem;
        }
      }

      p{
        margin: 0;
      }
    }
  }

  .linha{
    background-color: ${({theme}) => theme.colors.elements};
    height: 2px;
    border-radius: 50px;
    width: 40%;
  }
  
  .campos-modal-descricao{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .campo-caracteristicas {
      textarea[name="caracteristicasBeneficios"] {
        height: 20rem !important;
      }
    }

    .campo-midia{
      display: flex;
      flex-direction: column;
      .titulo-secao{
        text-align: left;
        .texto-secao{
          padding-left: 2px;
          color: ${({theme}) => theme.colors.placeholder};
        }
      }
      .logo-input-container-produto{
        min-height: 6rem !important;
        height: 6rem !important;
        margin: 0;

        .wrapper{
          justify-content: start;
          background-color: ${({theme}) => theme.colors.white};
          height: 6rem;
          padding: 1rem 4rem;
          >.icones{
            width: 30px;
            padding: 0;
          }

          .texto-wrapper{
            width: 100%;
            justify-content: start;
          }
        }
      }

      .midia-carregada {
        margin-top: 1rem;
        
        .miniatura-container {
          display: flex;
          align-items: end;
          gap: 1.2rem;
          
          .miniatura-imagem-wrapper {
            position: relative;
            display: inline-block;
            
            .miniatura-imagem {
              width: 50px;
              height: 50px;
              object-fit: cover;
              border-radius: 8px;
              flex-shrink: 0;
              cursor: pointer;
              transition: opacity 0.2s ease;
              display: block;
              
              &:hover {
                opacity: 0.8;
              }
            }
            
            .botao-remover-imagem {
              position: absolute;
              top: 2px;
              right: 2px;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background: ${({theme}) => theme.colors.elements};
              color: ${({theme}) => theme.colors.tertiary};
              border: 1px solid ${({theme}) => theme.colors.primary};
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 11px;
              font-weight: bold;
              z-index: 10;
              transition: all 0.2s ease;
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
            }
          }
          
          .info-imagem {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;
            flex: 1;
            
            .nome-arquivo {
              color: ${({theme}) => theme.colors.secondary};
              font-weight: 500;
            }
            
            .botao-alterar {
              background: none;
              border: none;
              color: ${({theme}) => theme.colors.primary};
              cursor: pointer;
              padding: 0;
              text-align: left;
              text-decoration: underline;
              
              &:hover {
                color: ${({theme}) => theme.colors.tertiary};
              }
            }
          }
        }
      }
    }

    .campo-caracteristicas{
      .textarea{
        textarea{
          height: 15rem;
          @media (max-width: 768px) {
            height: 15rem;
          }
        }
      }
    }

    .secao-quantidade-palavras,
    .campo-instrucoes{
      display: flex;
      flex-direction: column;
      gap: 8px;

      .titulo-secao{
        text-align: left;
        .texto-secao{
          padding-left: 2px;
          color: ${({theme}) => theme.colors.placeholder};
        }
      }
      
      .campos-quantidade{
        display: flex;
        gap: 16px;

        .campo-minimo,
        .campo-maximo{
          display: flex;
          flex-direction: column;
          gap: 8px;
          .label-campo-quantidade{
            text-align: left;
          }
        }

        
      }
    }
  }
  .imagem-resultado-ia{
    display: flex;
    justify-content: center;
    width: 100%;
    img{
      max-width: 100%;
      max-height: 50rem;
      border-radius: 15px;
      object-fit: contain;
    }
  }

  .botoes{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .cancelar{
      cursor: pointer;
      color: ${({theme}) => theme.colors.primary};
    }
  }
`;